var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVetrho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 55,
    viewBox: "0 0 64 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95213 39.1206L5.23852 46.4659L2.52084 39.1206C2.49658 39.0516 2.42783 39.0029 2.35099 39.0029H0.179287C0.0539181 39.0029 -0.035067 39.1328 0.0134628 39.2505L4.1385 49.5622C4.16681 49.6312 4.23153 49.6758 4.30432 49.6758H6.11205C6.18484 49.6758 6.24956 49.6312 6.27787 49.5622L10.4029 39.2505C10.4514 39.1328 10.3625 39.0029 10.2371 39.0029H8.122C8.04516 39.0029 7.98044 39.0516 7.95213 39.1206Z",
    fill: "url(#paint0_linear_106_5014)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9316 39.1853V49.42C11.9316 49.5174 12.0125 49.5985 12.1096 49.5985H19.7894C19.8865 49.5985 19.9674 49.5174 19.9674 49.42V47.7074C19.9674 47.61 19.8865 47.5289 19.7894 47.5289H14.2368V45.305H19.0332C19.1302 45.305 19.2111 45.2238 19.2111 45.1264V43.4139C19.2111 43.3165 19.1302 43.2353 19.0332 43.2353H14.2368V41.0845H19.7126C19.8096 41.0845 19.8905 41.0034 19.8905 40.906V39.1934C19.8905 39.096 19.8096 39.0149 19.7126 39.0149H12.1096C12.0085 39.0027 11.9316 39.0839 11.9316 39.1853Z",
    fill: "url(#paint1_linear_106_5014)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6255 39.1855V40.9752C21.6255 41.0726 21.7064 41.1537 21.8034 41.1537H24.8365V49.4202C24.8365 49.5176 24.9174 49.5987 25.0145 49.5987H26.9799C27.077 49.5987 27.1579 49.5176 27.1579 49.4202V41.1537H30.191C30.2881 41.1537 30.3689 41.0726 30.3689 40.9752V39.1855C30.3689 39.0881 30.2881 39.007 30.191 39.007H21.8034C21.7064 39.0029 21.6255 39.0841 21.6255 39.1855Z",
    fill: "url(#paint2_linear_106_5014)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5403 44.1485C37.6726 44.1485 38.3197 43.5438 38.3197 42.651V42.6186C38.3197 41.6203 37.6282 41.1049 36.4958 41.1049H34.1866V44.1485H36.5403ZM31.8652 39.1854C31.8652 39.088 31.9461 39.0068 32.0432 39.0068H36.6899C38.0326 39.0068 39.0719 39.3842 39.7675 40.0822C40.3539 40.6707 40.6734 41.5066 40.6734 42.505V42.5374C40.6734 44.2459 39.7554 45.3213 38.4127 45.8204L40.7988 49.3226C40.8797 49.4403 40.7947 49.6026 40.6491 49.6026H38.3682C38.3076 49.6026 38.251 49.5742 38.2186 49.5215L36.0105 46.21H34.1866V49.42C34.1866 49.5174 34.1057 49.5986 34.0086 49.5986H32.0432C31.9461 49.5986 31.8652 49.5174 31.8652 49.42V39.1854Z",
    fill: "url(#paint3_linear_106_5014)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0972 39.1855V43.199H44.8145V39.1855C44.8145 39.0881 44.7336 39.007 44.6366 39.007H42.6711C42.574 39.007 42.4932 39.0881 42.4932 39.1855V49.4202C42.4932 49.5176 42.574 49.5987 42.6711 49.5987H44.6366C44.7336 49.5987 44.8145 49.5176 44.8145 49.4202V45.3458H49.0972V49.4202C49.0972 49.5176 49.1781 49.5987 49.2752 49.5987H51.2407C51.3377 49.5987 51.4186 49.5176 51.4186 49.4202V39.1855C51.4186 39.0881 51.3377 39.007 51.2407 39.007H49.2752C49.1781 39.0029 49.0972 39.0841 49.0972 39.1855Z",
    fill: "url(#paint4_linear_106_5014)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5693 44.3311V44.3027C61.5693 42.4847 60.2429 40.971 58.3704 40.971C56.502 40.971 55.2038 42.4522 55.2038 44.2702V44.3027C55.2038 46.1167 56.5303 47.6304 58.4027 47.6304C60.2711 47.6304 61.5693 46.1451 61.5693 44.3311ZM52.7773 44.3311V44.3027C52.7773 41.2916 55.1472 38.8242 58.4027 38.8242C61.6583 38.8242 63.9999 41.2591 63.9999 44.2743V44.3068C63.9999 47.3179 61.63 49.7853 58.3744 49.7853C55.1148 49.7771 52.7773 47.3423 52.7773 44.3311Z",
    fill: "url(#paint5_linear_106_5014)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.235 35.7685C21.4111 35.7685 19.8056 34.7377 19.0412 33.0779L6.96131 6.8542C6.26976 5.35268 6.38705 3.61986 7.27272 2.22792C8.16243 0.831915 9.679 0 11.329 0H21.678C23.5464 0 25.2611 1.09975 26.0457 2.80417L30.7369 12.9861C31.0968 13.7652 30.7571 14.6945 29.9806 15.0557C29.2001 15.4169 28.278 15.076 27.9181 14.2968L23.2269 4.11495C22.9478 3.51029 22.3412 3.12071 21.678 3.12071H11.329C10.7345 3.12071 10.2128 3.40883 9.8893 3.91204C9.56981 4.41525 9.52936 5.0118 9.7801 5.55153L21.86 31.7793C22.2361 32.5991 23.0085 32.6599 23.235 32.6599C23.4615 32.6599 24.2298 32.595 24.61 31.7793L37.9921 2.80417C38.7767 1.1038 40.4914 0.00404972 42.3598 0.00404972H52.7168C54.3668 0.00404972 55.8794 0.835973 56.7691 2.22792C57.6588 3.62392 57.7761 5.35268 57.0845 6.8542L45.676 31.6697C44.6245 33.9545 42.3234 35.4316 39.816 35.4316H30.5508C29.6935 35.4316 28.9979 34.7336 28.9979 33.8733C28.9979 33.013 29.6935 32.315 30.5508 32.315H39.816C41.1182 32.315 42.3112 31.548 42.8572 30.363L54.2657 5.55153C54.5124 5.0118 54.472 4.41119 54.1525 3.91204C53.833 3.40883 53.3073 3.12476 52.7168 3.12476H42.3598C41.6965 3.12476 41.0899 3.51435 40.8108 4.11901L27.4288 33.0941C26.6644 34.7377 25.0589 35.7685 23.235 35.7685Z",
    fill: "url(#paint6_linear_106_5014)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.304688 51.5059H0.688887V54.5779H2.61388V54.935H0.304688V51.5059Z",
    fill: "#B1B1B1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93652 53.2347V53.2265C3.93652 52.281 4.64426 51.4531 5.68765 51.4531C6.72699 51.4531 7.42663 52.2729 7.42663 53.2184V53.2265C7.42663 54.1721 6.71889 54.9999 5.6755 54.9999C4.63616 54.9959 3.93652 54.1802 3.93652 53.2347ZM7.02626 53.2347V53.2265C7.02626 52.4474 6.46007 51.8102 5.67955 51.8102C4.89903 51.8102 4.34094 52.4393 4.34094 53.2184V53.2265C4.34094 54.0057 4.90713 54.6428 5.6917 54.6428C6.46817 54.6388 7.02626 54.0138 7.02626 53.2347Z",
    fill: "#B1B1B1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04395 53.2347V53.2265C9.04395 52.281 9.75168 51.4531 10.7951 51.4531C11.8344 51.4531 12.534 52.2729 12.534 53.2184V53.2265C12.534 54.1721 11.8263 54.9999 10.7829 54.9999C9.73953 54.9999 9.04395 54.1802 9.04395 53.2347ZM12.1296 53.2347V53.2265C12.1296 52.4474 11.5634 51.8102 10.7829 51.8102C10.0024 51.8102 9.44431 52.4393 9.44431 53.2184V53.2265C9.44431 54.0057 10.0105 54.6428 10.7951 54.6428C11.5715 54.6388 12.1296 54.0138 12.1296 53.2347Z",
    fill: "#B1B1B1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3013 51.5059H14.6855V53.5552L16.6509 51.5059H17.1483L15.6844 53.0074L17.2131 54.939H16.7278L15.4134 53.2752L14.6855 54.0138V54.935H14.3013V51.5059Z",
    fill: "#B1B1B1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8027 51.5059H19.1869V54.939H18.8027V51.5059Z",
    fill: "#B1B1B1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1401 51.5059H21.5L23.6556 54.2573V51.5059H24.0317V54.939H23.7243L21.5162 52.1268V54.939H21.1401V51.5059Z",
    fill: "#B1B1B1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8032 53.2347V53.2265C25.8032 52.285 26.4907 51.4531 27.5179 51.4531C28.0963 51.4531 28.4521 51.6195 28.7919 51.9076L28.5411 52.1998C28.2782 51.9685 27.983 51.8062 27.5018 51.8062C26.7455 51.8062 26.2036 52.4474 26.2036 53.2144V53.2225C26.2036 54.0422 26.7253 54.6509 27.5584 54.6509C27.9507 54.6509 28.3106 54.5008 28.5452 54.306V53.4538H27.5058V53.1048H28.9172V54.4724C28.5977 54.7565 28.1205 54.9959 27.5422 54.9959C26.4665 54.9959 25.8032 54.2127 25.8032 53.2347Z",
    fill: "#B1B1B1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0611 51.863H32.9126V51.5059H35.6019V51.863H34.4534V54.939H34.0611V51.863Z",
    fill: "#B1B1B1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2764 51.5059H37.6606V53.0317H39.6341V51.5059H40.0223V54.939H39.6341V53.3929H37.6606V54.939H37.2764V51.5059Z",
    fill: "#B1B1B1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9434 51.5059H43.4154C43.836 51.5059 44.1717 51.6317 44.386 51.8508C44.5519 52.0172 44.6489 52.2566 44.6489 52.5285V52.5366C44.6489 53.1048 44.2566 53.4375 43.7228 53.5349L44.7743 54.939H44.3011L43.3103 53.6039H42.3316V54.939H41.9474V51.5059H41.9434ZM43.3791 53.259C43.8927 53.259 44.2607 52.9952 44.2607 52.5529V52.5447C44.2607 52.1227 43.9371 51.867 43.3871 51.867H42.3316V53.259H43.3791Z",
    fill: "#B1B1B1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2788 53.2347V53.2265C46.2788 52.281 46.9865 51.4531 48.0299 51.4531C49.0693 51.4531 49.7689 52.2729 49.7689 53.2184V53.2265C49.7689 54.1721 49.0612 54.9999 48.0178 54.9999C46.9744 54.9959 46.2788 54.1802 46.2788 53.2347ZM49.3645 53.2347V53.2265C49.3645 52.4474 48.7983 51.8102 48.0178 51.8102C47.2373 51.8102 46.6792 52.4393 46.6792 53.2184V53.2265C46.6792 54.0057 47.2454 54.6428 48.0299 54.6428C48.8064 54.6388 49.3645 54.0138 49.3645 53.2347Z",
    fill: "#B1B1B1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4834 53.5025V51.5059H51.8676V53.4781C51.8676 54.2167 52.2599 54.6347 52.915 54.6347C53.5459 54.6347 53.9463 54.2532 53.9463 53.5025V51.5059H54.3345V53.47C54.3345 54.4683 53.7643 54.9878 52.9069 54.9878C52.0577 54.9918 51.4834 54.4724 51.4834 53.5025Z",
    fill: "#B1B1B1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0454 53.2347V53.2265C56.0454 52.285 56.7329 51.4531 57.7601 51.4531C58.3384 51.4531 58.6943 51.6195 59.034 51.9076L58.7833 52.1998C58.5204 51.9685 58.2252 51.8062 57.7439 51.8062C56.9877 51.8062 56.4458 52.4474 56.4458 53.2144V53.2225C56.4458 54.0422 56.9675 54.6509 57.8006 54.6509C58.1928 54.6509 58.5528 54.5008 58.7873 54.306V53.4538H57.748V53.1048H59.1594V54.4724C58.8399 54.7565 58.3627 54.9959 57.7844 54.9959C56.7086 54.9959 56.0454 54.2127 56.0454 53.2347Z",
    fill: "#B1B1B1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.979 51.5059H61.3673V53.0317H63.3408V51.5059H63.729V54.939H63.3408V53.3929H61.3673V54.939H60.9831V51.5059H60.979Z",
    fill: "#B1B1B1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_5014",
    x1: -2.49706,
    y1: 48.2754,
    x2: 61.2404,
    y2: 4.10506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922,
    stopColor: "#00EECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_5014",
    x1: 1.65894,
    y1: 54.2723,
    x2: 65.3964,
    y2: 10.1019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922,
    stopColor: "#00EECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_5014",
    x1: 4.41125,
    y1: 58.244,
    x2: 68.1487,
    y2: 14.0736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922,
    stopColor: "#00EECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_5014",
    x1: 8.30848,
    y1: 63.8676,
    x2: 72.046,
    y2: 19.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922,
    stopColor: "#00EECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_5014",
    x1: 11.7652,
    y1: 68.8558,
    x2: 75.5026,
    y2: 24.6855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922,
    stopColor: "#00EECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_106_5014",
    x1: 15.4915,
    y1: 74.2329,
    x2: 79.229,
    y2: 30.0626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922,
    stopColor: "#00EECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_106_5014",
    x1: -7.54456,
    y1: 40.9918,
    x2: 56.1929,
    y2: -3.17853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922,
    stopColor: "#00EECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetrho);
export default __webpack_public_path__ + "static/media/vetrho.14dfa52712916ae73c188683f10481f8.svg";
export { ForwardRef as ReactComponent };